const outlets = {
  CARD_BODY: 'card-body',
  _BLANK: ''
};
export const ComponentOutlets = outlets;
